<div class="d-flex">
    <wdx-file-icon [fileIndex]="fileIndex" class="me-1"></wdx-file-icon>
    @if (clickCallback) {
        <button
            type="button"
            class="btn btn-link btn-sm align-baseline text-start text-truncate"
            (click)="handleClick()"
            [title]="label"
        >
            {{ label }}
        </button>
    } @else {
        <span class="text-truncate" [title]="label">
            {{ label }}
        </span>
    }
</div>
